import {Req} from 'quickstart/types'
import {MetaProps, partitionMetaProps} from 'quickstart/utils'
import {ComponentProps} from 'react'
import * as B from '../block'
import {Config} from './admin'

export const IMG_WIDTH = 900

type CoverAreaProps = (
  | ComponentProps<typeof B.VideoPlayer>
  | ComponentProps<typeof B.MetaThumb>
) &
  Pick<Config, 'alignment'> &
  Req<MetaProps, 'metaType' | 'tizraId'> & {
    oEmbed: ReturnType<typeof B.useOEmbed>
    singleColumn: boolean
  }

export const Cover = ({
  alignment,
  oEmbed,
  singleColumn,
  ...mixed
}: CoverAreaProps) => {
  const [metaProps, props] = partitionMetaProps(mixed)
  return oEmbed?.html ? (
    <B.VideoPlayer oEmbed={oEmbed} {...props} />
  ) : (
    <B.MetaThumb
      imgWidth={IMG_WIDTH}
      loading="eager"
      shadowed
      {...(singleColumn
        ? {
            position: alignment,
            minRatio: 1.78,
          }
        : {
            minRatio: 2 / 3,
          })}
      {...metaProps}
      {...props}
    />
  )
}

Cover.displayName = 'HeaderBlock.Cover'
